const THN_LOADER_SRC =
  "https://www.thehotelsnetwork.com/js/loader.js?property_id=1158100"

const THN_SCRIPT_SELECTOR =
  'script[src*="thehotelsnetwork.com"][src*="1158100"]'

/**
 * True for Kayaam Wellness microsite paths (current, legacy, and wifi/compendium).
 * @param {string} [pathname]
 */
function isKayaamWellnessPath(pathname = "") {
  const p = String(pathname).toLowerCase()
  return (
    p.includes("/resort/kayaam-wellness") ||
    p.includes("/resort/kayaam-house") ||
    p.includes("/kayaam-wellness/") ||
    p === "/kayaam-wellness" ||
    p.endsWith("/kayaam-wellness")
  )
}

/**
 * Whether the THN loader script tags are already in the document.
 */
function hasThnLoaderScripts() {
  if (typeof document === "undefined") return false
  return document.querySelectorAll(THN_SCRIPT_SELECTOR).length > 0
}

/**
 * Inject the THN loader once into <head> (client-side).
 */
function ensureThnLoaderScripts() {
  if (typeof document === "undefined") return
  if (hasThnLoaderScripts()) return

  const headScript = document.createElement("script")
  headScript.src = THN_LOADER_SRC
  headScript.async = true
  headScript.setAttribute("data-thn-loader", "head")
  document.head.appendChild(headScript)
}

module.exports = {
  THN_LOADER_SRC,
  THN_SCRIPT_SELECTOR,
  isKayaamWellnessPath,
  hasThnLoaderScripts,
  ensureThnLoaderScripts,
}
